import { Th } from "@chakra-ui/react";
import styled from "styled-components/macro";

export const ThStyledBlue = styled(Th)`
  border-bottom: 1px solid #1f7ac3 !important;
  background-color: ${(props) => props.Color ?? ""};
  cursor: ${(props) => (props.cursor === true ? "pointer" : null)};
`;
